/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SupportOnly/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Children from 'Simple/Children'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SupportOnly({
  children,
  viewPath = "/DesignSystem/SupportOnly"
  
}) {
let authAccessTokenDataIsSupportValueData = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.is_support',
})
  return (<React.Fragment
>
<fromFlow.When is={authAccessTokenDataIsSupportValueData}>
<Children
  viewPath={`${viewPath}/Children`}
 data="auth.access_token_data.is_support"
>
{children}
</Children>
</fromFlow.When>
</React.Fragment>)
}